import React, { useEffect, useRef, useState } from "react";
import { Modal } from "antd";
import { CloseOutlined, DownloadOutlined } from "@ant-design/icons";
import profile from "../../../assets/images/ProfileImage.jpg";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { MdDownloadForOffline } from "react-icons/md";
import { IoShareSocial } from "react-icons/io5";
import { QRCodeCanvas } from "qrcode.react";
import PatientService from "../../../Services/PatientService";
import MedicalService from "../../../Services/MedicalService";
import ChronicConditionService from "../../../Services/ChronicConditionService";
import moment from "moment";
import EmcIcon from "../../../assets/images/Emcicon.png";
import UserIcon from "../../../assets/images/ProfileImage.jpg";
import DrugIcon from "../../../assets/images/DrugIcon.png";
import ChronicIcon from "../../../assets/images/ChronicIcon.png";
import InsuranceIcon from "../../../assets/images/InsuranceIcon.png";
import MedicationsIcon from "../../../assets/images/MedicationIcon.png";
import Cardbg from "../../../assets/images/Cardbg.png";
import CardLogo from "../../../assets/images/Cardlogo.png";
import { FaArrowRightLong } from "react-icons/fa6";
import { AiOutlineIdcard } from "react-icons/ai";
import { FiDownload } from "react-icons/fi";




function EmergencyData({ permissionData }) {
  const [text, setText] = useState("https://ant.design/");
  let patientDatalits = JSON.parse(localStorage.getItem("patientData"));
  const frontRef = useRef();
  const backRef = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [image, setImage] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [patientData, setPatientData] = useState();
  const [patientQrData, setPatientQrData] = useState();
  const [medicationData, setMedicationData] = useState([]);
  const [drugData, setDrugData] = useState([]);
  const [chronicData, setChronicData] = useState([]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
    }
  };

  const [isFlipped, setIsFlipped] = useState(false);

  const handleCardClick = () => {
    setIsFlipped((prev) => !prev);
  };

  const handleDownload = async () => {
    const pdf = new jsPDF();
    const frontSide = frontRef.current;
    const backSide = backRef.current;

    if (!frontSide || !backSide) return;

    try {
      backSide.style.display = "none";

      const frontCanvas = await html2canvas(frontSide, {
        scale: 3,
        useCORS: true,
      });
      const frontImage = frontCanvas.toDataURL("image/png");

      frontSide.style.display = "none";
      backSide.style.display = "block";
      backSide.style.transform = "none";
      backSide.style.backfaceVisibility = "visible";

      const backCanvas = await html2canvas(backSide, {
        scale: 3,
        useCORS: true,
      });
      const backImage = backCanvas.toDataURL("image/png");

      frontSide.style.display = "block";
      backSide.style.display = "none";

      const imgWidth = 180;
      const frontHeight = (frontCanvas.height * imgWidth) / frontCanvas.width;
      const backHeight = (backCanvas.height * imgWidth) / backCanvas.width;

      pdf.addImage(frontImage, "PNG", 10, 10, imgWidth, frontHeight);
      pdf.addImage(
        backImage,
        "PNG",
        10,
        20 + frontHeight,
        imgWidth,
        backHeight
      );

      pdf.save("Emergency_MedicalCard.pdf");
    } finally {
      frontSide.style.display = "block";
      backSide.style.display = "block";
      backSide.style.transform = "rotateY(180deg)";
      backSide.style.backfaceVisibility = "hidden";
    }
  };

  const PaitentDetails = () => {
    const payload = {
      patientId: patientDatalits?.patientId,
      status: 1,
    };
    PatientService.HSPatientData(payload).then((result) => {
      setPatientData(result?.data[0]);
    });
  };

  useEffect(() => {
    let patienObject = localStorage.getItem("patientData");
    let patientDataV = patienObject ? JSON.parse(patienObject) : null;
    // setPatientData(patientDataV);
    Medication();
    AllegyDetails();
    ChronicConditions();
    PaitentDetails();
  }, []);

  useEffect(() => {
    PatientEmergencyData();
  }, [permissionData]);
  const PatientEmergencyData = () => {
    let patienObject = localStorage.getItem("patientData");
    let patientDataV = patienObject ? JSON.parse(patienObject) : null;
    let payload = {
      status: 1,
      patientId: patientDataV?.patientId,
    };
    MedicalService.PatientQrList(payload).then((result) => {
      if (result?.data[0]?.healthCardUrl) {
        let url =
          "https://doctor-dev.doxzon.com/emergencyqr/" +
          result?.data[0]?.healthCardUrl;
        setPatientQrData(url);
      }
    });
  };

  const AllegyDetails = () => {
    const payload = {
      patientCode: patientDatalits?.patientId,
      status: 1,
    };
    MedicalService.PatientAllergiesList(payload).then((result) => {
      setDrugData(result.data);
    });
  };
  const Medication = () => {
    const payload = {
      patientCode: patientDatalits?.patientId,
      status: 1,
    };
    MedicalService.PatientMedication(payload).then((result) => {
      setMedicationData(result.data);
    });
  };

  const ChronicConditions = () => {
    const payload = {
      patientId: patientDatalits?.patientId,
      status: 1,
    };
    ChronicConditionService.PatientchronicConditions(payload).then((result) => {
      setChronicData(result.data);
    });
  };

  const calculateAge = (dobString) => {
    const dobData = dobString;
    const dobYear = dobData?.split("/")[2];
    const currYear = new Date().getFullYear();
    if (dobYear) {
      const patientAge = currYear - Number(dobYear);
      return patientAge;
    }
  };

  const convertUTCDate = (date, format) => {
    if (!format) {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes()
      );
    }
    format = format || "MM/DD/YYYY";
    return moment(new Date(date)).utc().format(format);
  };

  const generateQRCard = () => {
    let patienObject = localStorage.getItem("patient");
    let patientDataV = patienObject ? JSON.parse(patienObject) : null;
    const userObj = localStorage.getItem("login_result");
    const userData = userObj ? JSON.parse(userObj) : null;
    let payload = {
      createdBy: userData?.user?.userId,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      modifiedBy: userData?.user?.userId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      patientId: patientDataV?.patientId,
      status: 1,
    };
    MedicalService.GenerateQr(payload).then((result) => {
      PatientEmergencyData();
    });
  };

  return (
    <div className="border rounded-lg">
      {/* <div className=" h-[12%] bg-secondaryColor flex items-center justify-center rounded-lg p-2">
        <h1 className="font-bold text-sm text-normal text-white text-center">
          Emergency Medical Data
        </h1>
      </div> */}
      <div className=" bg-brand-lightBg">
        <div className="p-3">
          <div className="flex justify-between mb-2">
            <h1 className="text-sm font-bold text-gray-700">
              Emergency Medical Data
            </h1>
            <div className="flex gap-2 items-center">
              <img src={EmcIcon} alt="" />
              <h3
                className="text-primaryColor text-xs font-bold cursor-pointer"
                onClick={showModal}
              >
                View EMC
              </h3>
            </div>
          </div>
          <hr />
          <div className=" h-[300px] overflow-y-auto scrollWidth ">
            <div className="flex gap-3 mt-1">
              <div className="">
                <div className="flex gap-3 items-center">
                  <img src={UserIcon} alt="" className="w-14 h-14 rounded-md" />
                  <div className=" space-y-1">
                    <h5 className="text-xs font-medium text-gray-500">
                      {/* Name:{" "} */}
                      <span className="text-xs text-[#004B73] font-bold">
                        {patientData?.salutation +
                          " " +
                          patientData?.firstName +
                          " " +
                          patientData?.lastName}
                      </span>
                    </h5>
                    <div className="flex gap-3 items-center">
                      <h5 className="text-xs font-medium text-[#333333]">
                        <span className="text-xs font-semibold">
                          {calculateAge(patientData?.ageDob)}
                        </span>
                      </h5>

                      {/* Vertical line */}
                      <div className="h-4 border-l-2 border-gray-300"></div>

                      <h5 className="text-xs font-medium text-[#333333]">
                        <span className="text-xs font-semibold">
                          {patientData?.dob}
                        </span>
                      </h5>

                      {/* Vertical line */}
                      <div className="h-4 border-l-2 border-gray-300"></div>

                      <h5 className="font-semibold text-sm text-[#333333]">
                        {patientData?.bloodGroup}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h5 className="text-xs font-medium text-[#189FAA] mt-2 ">
              Address:{" "}
              <p className="text-xs text-black font-bold">
                {patientData?.address1}
              </p>
            </h5>
            <div className="border shadow-lg rounded-lg mt-3 p-2">
              {patientQrData ? (
                <div className="flex justify-center gap-2 items-center w-[90%] m-auto">
                  <p className="text-xs font-sans font-medium text-center flex items-center gap-3">
                    Scan for patient <br /> details
                    <FaArrowRightLong className="text-primaryColor" />
                  </p>
                  <div class="inline-block group mt-1">
                    <QRCodeCanvas value={patientQrData} size={90} />
                  </div>
                </div>
              ) : (
                <>
                  <div className="w-full flex justify-end">
                    <button
                      className="border rounded-lg px-3 text-xs py-1 bg-[#189FAA] font-semibold text-white hover:bg-[#338f97]"
                      onClick={() => generateQRCard()}
                    >
                      Generate QR Code
                    </button>
                  </div>
                </>
              )}
            </div>
            <div className="mt-2">
              <div className={`${drugData.length === 1 ? "flex gap-2" : ""}`}>
                <div className="flex gap-2">
                  <img src={DrugIcon} alt="" />
                  <p className="font-semibold text-xs mt-1">Drug Allergies</p>
                </div>
                <div
                  className={`border rounded-lg p-2 grid mt-2  
                  ${drugData.length === 1 ? "block" : ""} 
                  ${drugData.length > 15 ? "md:grid-cols-2" : "md:grid-cols-2"} 
                  grid-cols-2`}
                >
                  {drugData?.map((item, idx) => (
                    <p
                      key={idx}
                      className="text-xs font-medium font-sans text-[#333333]"
                    >
                      {item.drugAllergy}
                    </p>
                  ))}
                </div>
              </div>
              <hr className="mt-2" />
              <div
                className={`${chronicData.length === 1 ? "flex gap-2" : ""}`}
              >
                <div className="flex gap-2 mt-2">
                  <img src={ChronicIcon} alt="" />
                  <p className="font-semibold text-xs mt-1">
                    Chronic Conditions
                  </p>
                </div>{" "}
                <div
                  className={`border rounded-lg p-2 grid mt-2  
                  ${chronicData.length === 1 ? "block" : ""} 
                  ${
                    chronicData.length > 15
                      ? "md:grid-cols-2"
                      : "md:grid-cols-2"
                  } 
                  grid-cols-2`}
                >
                  {chronicData?.map((item, idx) => (
                    <>
                      <div key={idx} className="">
                        <p className="text-xs font-medium text-[#333333] truncate">
                          {item.chronicDescription}
                        </p>
                      </div>
                    </>
                  ))}
                </div>
              </div>
              <hr className="mt-2" />
              <div className="mt-2">
                <div className="flex gap-2">
                  <img src={InsuranceIcon} alt="" />
                  <p className="font-semibold text-xs">Insurance Number</p>
                </div>{" "}
                <p className="font-semibold text-xs font-sans ml-5 text-[#EEB205]">
                  {patientData?.insurance}
                </p>
              </div>
              <hr className="mt-2" />
              <div className="mt-2">
                <div className="flex gap-2">
                  <img src={MedicationsIcon} alt="" />
                  <p className="font-semibold text-xs mt-1">
                    Current Medications
                  </p>
                </div>{" "}
                <div className="overflow-x-auto scrollwidth mt-2">
                  <div className="grid grid-cols-1 gap-2">
                    {medicationData?.map((row, index) => (
                      <div
                        key={index}
                        className="bg-white p-2 rounded-lg shadow-md border border-gray-300"
                      >
                        <div>
                          <div className="flex justify-between text-[#333333] text-xs">
                            <h3 className="font-bold">{row.drugName}</h3>
                            <p className="font-medium">{row.dosage}</p>
                            <p className="font-medium">{row.frequency}</p>
                          </div>
                          <div className="flex justify-between">
                            <div className="flex gap-2 items-center">
                              <h6 className="text-xs font-medium">
                                On set Date:
                              </h6>
                              <h6 className="border rounded-md text-[10px] p-1">
                                {row.startCreatedTime?.slice(0, 11)}
                              </h6>
                            </div>
                            {/* <div className="flex gap-2 items-center">
                            <h6 className="text-xs text-[#189FAA] font-medium">
                              To:
                            </h6>
                            <h6 className="border rounded-md text-[10px] p-1">
                              {row.endCreatedTime?.slice(0, 11)}
                            </h6>
                          </div> */}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        title={
          <div className="flex justify-end space-x-4">
            <div className="w-7 h-7 bg-[#DDFCFF] rounded-full flex items-center justify-center">
            <FiDownload

              className="text-[#189FAA] cursor-pointer font-bold w-4 h-4 mb-1"
              onClick={handleDownload}
            />
            </div>
            <CloseOutlined
              className="text-white cursor-pointer"
              onClick={handleCancel}
            />
          </div>
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={500}
        footer={
          <div>
            {/* <div className="flex justify-end space-x-4 mt-6">
              <button className="px-4 py-1 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-300" onClick={handleDownload}>
                Download
              </button>
            </div> */}
          </div>
        }
      >
        <div
          className="relative w-full h-[250px] perspective cursor-pointer"
          onClick={handleCardClick}
        >
          <div
            className={`relative w-full h-full transform-style-preserve-3d transition-transform duration-700 ${
              isFlipped ? "rotate-y-180" : ""
            }`}
          >
            <div
              className="absolute w-full backface-hidden border-2 border-slate-200 rounded-lg bg-white"
              ref={frontRef}
            >
              <div
                className="h-12 rounded-md flex justify-between items-center px-2"
                style={{
                  backgroundImage: `url(${Cardbg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <p className="font-medium text-sm text-white">
                  Emergency Medical Card
                </p>
                <img src={CardLogo} alt="" />
              </div>

              <div className="w-full p-2 flex justify-evenly">
                <div className="flex gap-5 w-[75%] items-center">
                  <div className="w-24 h-24 bg-white border rounded-xl flex items-center justify-center overflow-hidden">
                    {patientData?.photoNameBase64 ? (
                      <img
                        src={
                          "data:image/jpeg;base64," +
                          patientData?.photoNameBase64
                        }
                        alt=""
                        className="w-full h-full object-cover rounded-xl"
                      />
                    ) : (
                      <img
                        src={profile}
                        alt=""
                        className="w-full h-full object-cover "
                      />
                    )}
                  </div>
                  <div className="font-inter ">
                    <h4 className="text-sm font-normal text-[#5C5C5C] mt-2">
                      Name:{" "}
                      <span className="font-bold text-[#197EBC]">
                        {patientData?.salutation +
                          " " +
                          patientData?.firstName +
                          " " +
                          patientData?.lastName}
                      </span>
                    </h4>
                    <h4 className="text-sm font-normal text-[#5C5C5C] mt-2">
                      Age:{" "}
                      <span className="font-bold text-[#333333]">
                        {calculateAge(patientData?.ageDob)}
                      </span>
                    </h4>
                    <h4 className="text-sm font-normal text-[#5C5C5C] mt-2">
                      BloodGroup:{" "}
                      <span className="font-bold text-[#333333]">
                        {patientData?.bloodGroup}
                      </span>
                    </h4>
                    <h4 className="text-sm font-normal text-[#5C5C5C] mt-2">
                      Mobile No:{" "}
                      <span className="font-bold text-[#333333]">
                        {patientData?.mobile}
                      </span>
                    </h4>
                  </div>
                </div>
                <div className="w-[25%]">
                  <div className="w-24 h-24 rounded-lg flex items-center justify-center mt-3 bg-white border">
                    {patientQrData && (
                      <QRCodeCanvas
                        value={patientQrData}
                        size={80}
                        className="mt-2"
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="h-10 bg-[#002B42] flex items-center gap-3 justify-center mt-2 rounded-lg">
                <div className="bg-[#EF5050] w-24 h-6 rounded-md flex items-center justify-center">
                      <p className="text-white text-xs font-sans font-medium">Emergency</p>
                </div>
                  <h6 className="text-xs font-medium text-white">
                  Mobile Number:{" "}
                  <span className="text-sm font-semibold">
                    {patientData?.emergencyContact}
                  </span>
                </h6>
              </div>
              {/* <div className="flex justify-evenly items-center mt-2"> */}
                {/* <h6 className="text-xs font-medium">
                  Name:{" "}
                  <span className="text-sm font-semibold">
                    {patientData?.salutation +
                      " " +
                      patientData?.firstName +
                      " " +
                      patientData?.lastName}
                  </span>
                </h6> */}
           
              {/* </div> */}
            </div>
            <div
              className="absolute w-full bg-[#002B42] h-56 rounded-lg backface-hidden rotate-y-180 border-2 border-slate-200"
              ref={backRef}
            >
              {/* <div className="h-10 bg-white-800 rounded-md flex justify-center items-center">
                <p className="font-semibold text-center text-base mt-4 text-white">
                  Emergency Medical Card
                </p>
              </div> */}
           <div className="flex flex-col justify-between bg-[#002B42] rounded-md shadow h-full">
  <div className="flex flex-col items-center text-center justify-center px-4 py-6">
    <p className="text-sm font-semibold text-white mt-10">
      Access my personal Health Records At:
    </p>
    <a
      href={`${process.env.REACT_APP_FRONTEND_URL?.replace(/\/$/, "")}/PHR-ACCESS/${patientData?.patientId}`}
      target="_blank"
      rel="noopener noreferrer"
      className="text-[#189FAA] text-sm mt-1 font-bold underline hover:text-[#117a80] transition"
    >
      {`${process.env.REACT_APP_FRONTEND_URL?.replace(/^https?:\/\//, "")}/PHR-ACCESS`}
    </a>
  </div>

  {/* Bottom Section */}
  <div className="flex justify-center gap-3 items-center border-t border-gray-200 h-10 bg-gray-50 rounded-b-md">
    <p className="text-sm font-semibold w-24 h-7 bg-[#0AA0AC] rounded-md text-white flex items-center justify-center">
      Member ID
    </p>
    <div className="flex items-center gap-2">
      <AiOutlineIdcard className="w-5 h-5"/>
      <p>ID No:</p>
         <span className="text-sm font-semibold">
        {patientData?.patientId}
      </span>
      </div>
  </div>
</div>

            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default EmergencyData;
